import { ALL_TAB_PAGE_SIZE } from "../constants";

export type AllTabPage<T> = {
  page: number;
  pageCount: number;
  products: T[];
};

export const paginateAllTab = <T>(
  products: readonly T[],
  page: number,
  pageSize: number = ALL_TAB_PAGE_SIZE,
): AllTabPage<T> => {
  if (products.length === 0 || pageSize <= 0) {
    return { page: 0, pageCount: 0, products: [] };
  }

  const pageCount = Math.ceil(products.length / pageSize);
  const currentPage = Math.min(Math.max(Math.trunc(page), 0), pageCount - 1);
  const start = currentPage * pageSize;

  return {
    page: currentPage,
    pageCount,
    products: products.slice(start, start + pageSize),
  };
};
